import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { HelperService } from 'src/sb-tools/typescript/services/helper.service';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FocusDirective } from '../../../../sb-tools/typescript/directives/focus.directive';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
    selector: 'app-new-vendor-form',
    templateUrl: './new-vendor-form.component.html',
    styleUrls: ['./new-vendor-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, NgClass, TranslateModule, FocusDirective, TooltipModule],
})
export class NewVendorFormComponent {
    @Input() isAddingUser;

    @Output() addNewUser: EventEmitter<any> = new EventEmitter();
    @Output() closeForm: EventEmitter<any> = new EventEmitter();

    @ViewChild('vendorForm') public form: NgForm;

    email;
    emailValidationPattern = HelperService.emailValidationPattern;
    isGivingAccess;
    name = '';

    add() {
        this.addNewUser.emit([
            this.email,
            this.name.trim(),
            false,
            () => {
                this.close();
            },
        ]);
    }

    close() {
        this.name = '';
        this.email = '';
        this.isGivingAccess = '';
        this.closeForm.emit();
    }
}
